
import { useAuth } from '../contexts/Auth/authContext';
import { useUiVisibility } from '../contexts/UiVisibilityContext';

export const useRawTabVisible = (): boolean | null => {
  const { user } = useAuth();
  const { showRawTab, rawTabUsernames, ready } = useUiVisibility();

  if (!ready) return null;

  const username = user?.preferredUsername ?? null;
  if (rawTabUsernames.length > 0) {
    return !!username && rawTabUsernames.includes(username);
  }
  return showRawTab;
};
